import pinyin from "js-pinyin";

// 1. 自动兼容 Webpack 的不同模块导出方式（彻底防范 undefined 报错）
let pinyinInstance = pinyin;
if (pinyin && pinyin.default) {
  pinyinInstance = pinyin.default;
}

// 2. 检查库是否成功加载，若异常则降级为纯英文字符截取，确保即使库崩了页面也绝对不白屏
const hasPinyinLib = typeof pinyinInstance.setOptions === "function" && typeof pinyinInstance.getCamelChars === "function";

if (hasPinyinLib) {
  pinyinInstance.setOptions({ checkPolyphone: false, charCase: 0 });
} else {
  console.error("js-pinyin 库加载异常，已启用原生降级算法。");
}

/**
 * 1. 提取单个汉字/字符串的拼音大写首字母（含多音字硬编码修正）
 * @param {String} name 
 * @returns {String} 大写首字母 A-Z，无法识别则返回 #
 */
export function getFirstLetter(name) {
  if (!name || typeof name !== "string") return "#";

  const trimmedName = name.trim();
  
  // 针对高频金融/地理场景多音字进行硬编码矫正，双重保险
  if (trimmedName.startsWith("重庆") || trimmedName.startsWith("长沙") || trimmedName.startsWith("长春")) {
    return "C";
  }
  if (trimmedName.startsWith("厦门")) {
    return "X";
  }

  let firstLetter = "#";

  if (hasPinyinLib) {
    // 💡 核心修复：官方正确的 API 名称是 getCamelChars 
    const py = pinyinInstance.getCamelChars(trimmedName);
    firstLetter = py ? py.charAt(0).toUpperCase() : "#";
  } else {
    // 降级方案：如果第三方库挂了，直接截取首个英文字符
    const firstChar = trimmedName.charAt(0);
    if (/^[a-zA-Z]$/.test(firstChar)) {
      firstLetter = firstChar.toUpperCase();
    }
  }

  // 严格校验是否在 A-Z 范围内，不在则归类到 '#'
  if (!/^[A-Z]$/.test(firstLetter)) {
    firstLetter = "#";
  }

  return firstLetter;
}

/**
 * 2. 获取字符串的完整拼音（用于全拼模糊搜索）
 * @param {String} name 
 * @returns {String} 小写全拼
 */
export function getFullPinyin(name) {
  if (!name) return "";
  if (hasPinyinLib && typeof pinyinInstance.getFullChars === "function") {
    return pinyinInstance.getFullChars(name).toLowerCase();
  }
  return name.toLowerCase();
}

/**
 * 3. 核心通用方法：将扁平的数组自动转化为按 A-Z 分组并排序好的结构
 * @param {Array} list 原始数组
 * @param {String} textFieldName 对应文本字段的 Key 名（如 'bankName'）
 * @returns {Array} 格式化后的数组
 */
export function groupAndSortByLetter(list, textFieldName = "name") {
  if (!Array.isArray(list)) return [];

  const groups = {};

  // 1. 处理数据，为每项注入拼音和首字母
  const processedList = list.map(item => {
    const text = item[textFieldName] || "";
    return {
      ...item,
      _letter: getFirstLetter(text),
      _fullPinyin: getFullPinyin(text)
    };
  });

  // 2. 动态收集所有出现过的字母，并建立空分组
  const availableLetters = [...new Set(processedList.map(item => item._letter))].sort();
  
  // 确保 '#' 分组如果存在，永远排在最后面
  if (availableLetters.includes("#")) {
    const index = availableLetters.indexOf("#");
    availableLetters.splice(index, 1);
    availableLetters.push("#");
  }

  availableLetters.forEach(letter => {
    groups[letter] = [];
  });

  // 3. 将数据分发到对应的字母组中
  processedList.forEach(item => {
    if (groups[item._letter]) {
      groups[item._letter].push(item);
    }
  });

  // 4. 组装成最终 Vant IndexBar 所需的数组结构
  return availableLetters.map(letter => ({
    letter,
    list: groups[letter]
  }));
}